import { combineReducers } from 'redux';
import { awarenessTabReducer } from '../tabs/awareness/data/reducer';
import { adRecallTabReducer } from '../tabs/adRecall/data/reducer';
import { considerationTabReducer } from '../tabs/consideration/data/reducer';
import { imageTabReducer } from '../tabs/image/data/reducer';
import { valueForMoneyTabReducer } from '../tabs/valueformoney/data/reducer';
import { CHANGE_BPT_SCOPE_AXA_EVOLUTION, CHECKED_EVOLUTION_BRANDS } from './actions';
import { SCOPE_TYPES } from '../../../../../common/utils/utils';

const contentScopeReducer = (state = SCOPE_TYPES.BPT_AXA, action) => {
    switch (action.type) {
        case CHANGE_BPT_SCOPE_AXA_EVOLUTION:
            return action.payload;
        default:
            return state;
    }
};

const checkedEvolutionBrandsReducer = (state = [], action) => {
    switch (action.type) {
        case CHECKED_EVOLUTION_BRANDS:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    awarenessData: awarenessTabReducer,
    adRecallData: adRecallTabReducer,
    valueForMoneyData: valueForMoneyTabReducer,
    considerationData: considerationTabReducer,
    imageData: imageTabReducer,
    contentScope: contentScopeReducer,
    checkedEvolutionBrands: checkedEvolutionBrandsReducer,
});
